import $ from 'jquery';

if($('#country').length) {
  $('#canada-region').closest('.input-field').css('display', 'none');
  $('#usa-region').closest('.input-field').css('display', 'none');
  $('#country').on('change', function () {
    var country = ($('#country').val())
    if( country === 'Canada') {
      console.log(country)
      $('#usa-region').closest('.input-field').css('display', 'none');
      $('#canada-region').closest('.input-field').css('display', 'flex');
      $('#usa-region').prop('required', false);
      $('#canada-region').prop('required', true);
    }
    else if( country === 'United States') {
      console.log(country)
      $('#canada-region').closest('.input-field').css('display', 'none');
      $('#usa-region').closest('.input-field').css('display', 'flex');
      $('#canada-region').prop('required', false);
      $('#usa-region').prop('required', true);
    }
    else {
      $('#canada-region').closest('.input-field').css('display', 'none');
      $('#usa-region').closest('.input-field').css('display', 'none');
      $('#canada-region').prop('required', false);
      $('#usa-region').prop('required', false);
    }
  })
}
